export default __webpack_public_path__ + "static/media/avatarA7.3f035041.png";